type IFontProperty = {
  fontSize: string
}

export type ITheme = {
  //media queries should match bootstrap media queries
  mq: {
    sm: string
    md: string
    lg: string
    xl: string
  }
  colors: {
    primary: string
    primaryButtonHover: string
    buttonDisabled: string
    secondary: string
    textDarkblack: string
    textLightblack: string
    positive: string
    positive2: string
    positive3: string
    positive4: string
    primaryLightText: string
    secondaryLightText: string
    spartaGreen: string
    spartaGreen2: string
    secondaryHeading: string
    borderColor: string
    grey2: string
    linkColor: string
    yield: string
    lightBackground: string
    white: string
    navColor: string
    footerText: string
    alertGreen: string
    alertGreen2: string
    alertGrey: string
    warning2: string
    warning: string
    warningContrast: string
    alertRed: string
    danger: string
    cardHeaderFontColor: string
    boxShadow: string
  }
  backgrounds: {
    backGround1: string
    backGround2: string
    backGround3: string
    backGround4: string
    backGround5: string
  }
  font: {
    weight: {
      normal: number
      slightBold: number
      semiBold: number
      bold: number
    }
    size: {
      smaller: string
      small: string
      medium: string
      larger: string
      largest: string
    }
    caption: IFontProperty
    primaryButton: IFontProperty
    text: IFontProperty
  }
}

export interface IVehicleProps {
  id: string
  family: string
  fuelConsumption: number
  fuelType: string
  make: string
  payLoad: string
  procurementFee: number
  shadowPR: boolean
  style: string
  vehicleDescription: string
  vehicleImage: { base64Image: string }
  vehicleType: string
  year: string
}

export enum NextStepValue {
  ATO = 'ato',
  DEFERRED = 'deferred',
  INSURANCE = 'insurance',
  NONE = '',
}

export enum FinAppStatusValue {
  NONE = '',
  NOTSTARTED = 'notstarted',
  STARTED = 'started',
  COMPLETED = 'completed',
}

export enum VideoPlayerStyle {
  EMBEDDED,
  POPUP,
  EXPANDABLE,
}
